// extracted by mini-css-extract-plugin
export default {"maxHeightOfBodyCell":"200","body":"SentEmailTable_body__SknyD","hiddenBody":"SentEmailTable_hiddenBody__evs5Z","eye":"SentEmailTable_eye__peh4S","code":"SentEmailTable_code__8IlWW"};